export default __webpack_public_path__ + "static/media/Rose-Cake-2.0522d8fb.jpg";